/*
 * servicesAction.js
 * trt_cms2
 *
 * Created by Hisyam on 11/03/2020, 2:49 PM.
 * Copyright (c) 2020 Terato Tech. All rights reserved.
 */

import {
  ADD_SERVICE,
  ADD_SERVICE_FULFILLED,
  DELETE_SERVICE, DELETE_SERVICE_FULFILLED,
  FETCH_SERVICE,
  FETCH_SERVICE_FULFILLED,
  FETCH_SERVICES,
  FETCH_SERVICES_FULFILLED, RESET_REDIRECT_SERVICE,
  UPDATE_SERVICE, UPDATE_SERVICE_FULFILLED
} from "../types";
import {ofType} from "redux-observable";
import {
  debounceTime,
  switchMap,
  withLatestFrom,
  map,
  catchError,
  pluck,
  mapTo,
  distinctUntilChanged
} from "rxjs/operators";
import {ajax} from "rxjs/ajax";
import {SERVICES_API} from "../../config/api";
import {apiHeader, encodeQueryData} from "../../config/helper";
import {returnErrors} from "../messages/messagesAction";
import {of} from "rxjs";

export const fetchServices = (limit, offset, params={}) => ({type: FETCH_SERVICES, payload: {limit, offset, ...params}});
const fetchServicesFulfilled = payload => ({type: FETCH_SERVICES_FULFILLED, payload});
export const fetchServicesEpic = (action$, state$) => action$.pipe(
  ofType(FETCH_SERVICES),
  debounceTime(500),
  withLatestFrom(state$),
  switchMap(
    ([action, state]) => ajax.getJSON(SERVICES_API + `?${encodeQueryData(action.payload)}`, apiHeader(state))
      .pipe(
        map(fetchServicesFulfilled),
        catchError(({response, status}) => of(returnErrors(response, status)))
      )
  )
);

export const fetchService = id => ({type: FETCH_SERVICE, payload: id});
const fetchServiceFulfilled = payload => ({type: FETCH_SERVICE_FULFILLED, payload});
export const fetchServiceEpic = (action$, state$) => action$.pipe(
  ofType(FETCH_SERVICE),
  withLatestFrom(state$),
  switchMap(
    ([action, state]) => ajax.getJSON(SERVICES_API + `${action.payload}/`, apiHeader(state))
      .pipe(
        map(fetchServiceFulfilled),
        catchError(({response, status}) => of(returnErrors(response, status)))
      )
  )
);

export const addService = service => ({type: ADD_SERVICE, payload: service});
const addServiceFulfilled = payload => ({type: ADD_SERVICE_FULFILLED, payload});
export const addServiceEpic = (action$, state$) => action$.pipe(
  ofType(ADD_SERVICE),
  withLatestFrom(state$),
  switchMap(
    ([action, state]) => ajax.post(SERVICES_API, action.payload, apiHeader(state))
      .pipe(
        pluck('response'),
        map(addServiceFulfilled),
        catchError(({response, status}) => of(returnErrors(response, status)))
      )
  )
);

export const updateService = (id, service) => ({type: UPDATE_SERVICE, payload: service, id});
const updateServiceFulfilled = payload => ({type: UPDATE_SERVICE_FULFILLED, payload});
export const updateServiceEpic = (action$, state$) => action$.pipe(
  ofType(UPDATE_SERVICE),
  debounceTime(500),
  withLatestFrom(state$),
  switchMap(
    ([action, state]) => ajax.put(SERVICES_API + `${action.id}/`, action.payload, apiHeader(state))
      .pipe(
        catchError(({response, status}) => of(returnErrors(response, status)))
      )
  ),
  pluck('response'),
  withLatestFrom(state$),
  switchMap(
    ([response, state]) => ajax.getJSON(SERVICES_API + `${response.id}/`, apiHeader(state))
      .pipe(
        map(updateServiceFulfilled),
        catchError(({response, status}) => of(returnErrors(response, status)))
      )
  )
);

export const deleteService = id => ({type: DELETE_SERVICE, id});
const deleteServiceFulfilled = id => ({type: DELETE_SERVICE_FULFILLED, payload: id});
export const deleteServiceEpic = (action$, state$) => action$.pipe(
  ofType(DELETE_SERVICE),
  debounceTime(500),
  withLatestFrom(state$),
  switchMap(
    ([action, state]) => ajax.delete(SERVICES_API + `${action.id}/`, apiHeader(state))
      .pipe(
        map(() => deleteServiceFulfilled(action.id)),
        catchError(({response, status}) => of(returnErrors(response, status)))
      )
  )
);

export const resetRedirectServiceEpic = action$ => action$.pipe(
  ofType(ADD_SERVICE_FULFILLED, UPDATE_SERVICE_FULFILLED, DELETE_SERVICE_FULFILLED),
  mapTo({type: RESET_REDIRECT_SERVICE})
);

export const servicesEpic = [
  fetchServicesEpic,
  fetchServiceEpic,
  addServiceEpic,
  updateServiceEpic,
  deleteServiceEpic,
  resetRedirectServiceEpic,
];